'use client'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'

interface FlightSearchTabsProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
}

export const FlightSearchTabs = ({ isMobile, serverRecentSearches, hideMulticity }: FlightSearchTabsProps) => {
    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()
    const t = useTranslations('header')

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (newValue === 1) {
            // Hotels tab - navigate to /hotels
            window.location.href = `/${locale}/hotels`
        } else if (newValue === 2) {
            // Flights + Hotels tab - navigate to /flights-hotels
            window.location.href = `/${locale}/flights-hotels`
        } else {
            // Flights tab - stay on current page
            setTabValue(newValue)
        }
    }

    return (
        <FlightSearchTabsComponent
            t={t}
            tabValue={tabValue}
            onTabChange={handleTabChange}
            isMobile={isMobile}
            serverRecentSearches={serverRecentSearches}
            hideMulticity={hideMulticity}
        />
    )
}
